import React, {
  useContext,
} from 'react';
import BreakpointContext from '../../contexts/BreakpointContext';
import DesktopZoomImages from './DesktopZoomImages';
import MobileZoomImage from './MobileZoomImage';

export default function ZoomImages({
  orderedImages,
  productId,
  activeImage,
  setActiveImage,
  tmntData,
  handleImageErrorOrRemoval,
}) {
  const breakpoints = useContext(BreakpointContext);
  const isMobile = !breakpoints.xsmall;
  const altZoomImage = (type, imageId) => `${type} ${imageId.slice(-1)}`;

  return (
    isMobile ? (
      <MobileZoomImage
        productId={productId}
        activeImage={activeImage}
        altZoomImage={altZoomImage}
        handleImageErrorOrRemoval={handleImageErrorOrRemoval}
      />
    ) : (
      <DesktopZoomImages
        orderedImages={orderedImages}
        productId={productId}
        activeImage={activeImage}
        setActiveImage={setActiveImage}
        altZoomImage={altZoomImage}
        tmntData={tmntData}
        handleImageErrorOrRemoval={handleImageErrorOrRemoval}
      />
    )
  );
}
